import React, { Fragment } from "react";
import { Link } from "react-router";
import Loader from "../../components/loader";
import HorseRacingCompetitions from "../../components/horseRacingCompetitions";
import Config from "../../../config/main";
import HorseRacingSoon from "../../components/horseRacingSoon";
import { t } from "../../../helpers/translator";

export default function reactHorseRacingTemplate() {
    const { data: region, loaded, params: { sportId } } = this.props;
    if (region && loaded) {
        const { selectedRegionId } = this.state;
        return <React.Fragment>
            <div className="virtual-games-wrapper real-horse-r-w" ref={(el) => this.horseRacing = el}>
                <div className="r-h-r-regions">
                    <div className="competitions-nav-l">
                        <div className={`comp-s-item-v ${selectedRegionId === 'racing' ? "active" : ''}`} >
                            <p>{t("all races")}</p>
                            <Link to={`/horseRacing/${sportId}/racing`}><span className={`icon-racing`} /></Link>
                        </div>
                        {
                            region.map(item =>
                                <div className={`comp-s-item-v ${selectedRegionId === (item.id || -1).toString() ? "active" : ''}`} key={item.id} >
                                    <p>{item.name.toUpperCase()}</p>
                                    <i>{item.competition} {t("Competition")}</i>
                                    <Link to={`/horseRacing/${sportId}/${item.id}`}><span className={`flag-view-m icon-${item.alias.toLowerCase()}`} /></Link>
                                </div>
                            )
                        }
                    </div>
                </div>
                {
                    selectedRegionId === 'racing' ? (
                        <HorseRacingSoon sportId={sportId} />
                    ) : (
                        <Fragment>
                            <div className="title-h-nav-b">
                                <h3>{t("RACE TRACKS")}</h3>
                            </div>
                            {selectedRegionId && <HorseRacingCompetitions key={selectedRegionId} regionId={selectedRegionId} />}
                        </Fragment>
                    )
                }
                {
                    Config.terminal.scrollButtons && <div className="scroll-b-view-w">
                        <div className="single-s-b top-v" onClick={this.scroll(-150)} />
                        <div className="single-s-b bot-v" onClick={this.scroll(150)} />
                    </div>
                }
            </div>

        </React.Fragment>;
    }
    return <Loader />;
}